import React from 'react';

const noFound = `${EASYCOMMERCE.assets}admin/img/no-tax.png`;

const NoFound = ({ handleAddNew }) => {
    return (
        <>
            <div className="w-full text-center">
                <div>
                    <img
                        className="mx-auto w-[255px] h-[205px] mb-8"
                        src={noFound}
                        alt=""
                    />
                </div>
                <h2 className="mb-6 font-inter font-semibold text-xl leading-8 text-ec-placeholder">
                    No Taxation methods configured
                </h2>
                <button
                    type="button"
                    onClick={handleAddNew}
                    className="w-[125px] h-12 flex justify-center items-center gap-[8px] 
                        bg-white group border border-ec-primary rounded-lg 
                        text-ec-primary hover:text-white hover:bg-ec-primary focus:shadow-none 
                        focus:text-white focus:bg-ec-secondary lg:text-sm md:text-xs sm:text-sm 
                        transition-all ease-in-out duration-500 font-inter font-medium text-base text-center leading-[26px] mx-auto"
                >
                    <svg
                        class="w-4 h-4 font-medium"
                        data-slot="icon"
                        fill="none"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 4.5v15m7.5-7.5h-15"
                        ></path>
                    </svg>
                    Add Class
                </button>
            </div>
        </>
    );
};

export default NoFound;
